var exports = {
  "o": "xae11d333--9c4f10--block",
};

module.exports = exports;
